<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content p-2">
                <div v-for="(item, index) in saleReturnData" :key="index">
                    <div class="d-flex justify-content-center align-items-center p-1">
                        <span class="text-center">{{ item.bill_number }}</span>
                        <button class="btn btn-secondary btn-sm curosr-pointer mx-1"
                            @click="goToPrint(item.id)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                        <button class="btn btn-primary btn-sm"
                            @click="goToReturnEdit(item.id)"
                        >
                            <i class="fas fa-eye"></i>
                        </button>
                    </div>
                </div>

                <div class="col-12 text-center mt-2">
                    <button @click.prevent="onClickClose" class="btn btn-outline-secondary waves-effect">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
    <PosReturnPrintTrigger
        ref="posPrinter"
        :company="companyInfo"
        :billType="billType"
    />
</template>

<script setup>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from 'vue-router';
import PosReturnPrintTrigger from "@/components/molecule/company/pos-invoice/PosReturnPrintTrigger.vue";

const props = defineProps(['saleReturnData', 'companyInfo', 'billType', 'saleType']);
const $store = useStore();
const $route = useRoute();
const $router = useRouter();
const modalRef = ref(null);
const posPrinter = ref(null);

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

const goToPrint = (id) => {
    posPrinter.value.triggerPrint(id);
}

const goToReturnEdit = (id) => {
    const params = {
        ...$route.params,
        saleReturnId: id,
    }
    $router.push({
        name: 'edit-investigation-partial-bill-return',
        params: params,
        query: {
            ...$route.query,
            sale_type: props.saleType
        }
    })
    $store.state.isModalOpenTwo = false;
}
</script>
